const quadraticBezier = (
  p0: number,
  p1: number,
  p2: number,
  t: number
): number => {
  return (1 - t) * ((1 - t) * p0 + t * p1) + t * ((1 - t) * p1 + t * p2)
}

const linearLightGammaCorrected = (
  a: number,
  b: number,
  brightness: number
): number => {
  // This is just Linear Light, but with a higher `factor` than 2 to make the color shine through much more
  a /= 255
  b /= 255
  if (brightness > 0.5 && a < 0.5) {
    a = quadraticBezier(0, 0.5, 1, a)
  }
  const factor = 1.7
  const v = b + factor * a - 1
  return Math.floor(v * 255)
}

export default linearLightGammaCorrected
